<template>
  <div id="app">
    <!--     <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    -->
    <router-view :key="$route.fullPath" />

  </div>
</template>

<script>
//import mycard from "@/components/mycard.vue";

export default {
  created() {
    document.title = "厦门外图";
  },
  data() {
    return {
      //      msgbody:        '<h2><img src="http://img.baidu.com/hi/jx2/j_0003.gif" />内容支持图文混编及多种样式字体</h2> <p><img src="http://35.201.165.105:8000/storage/image/20200109/1578533290688040.jpg" title="1578533290688040.jpg" alt="1578533290688040.jpg" width="768" height="432" border="0" vspace="0" style="width:768px; height: 432px;" /></p>',
      //      msgtitle: "<span>标题</span>"
      //      mymodel:"2gjzsjs",
    };
  },

  components: {
    /* 
    qtindex,
    htindex,
    login,
    test,
    newsitem */
    //myxls
    // mycard
  }
};
</script>

<style lang="stylus">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
}

/* .el-tree-node:focus > .el-tree-node__content {
  background-color: #ccc !important;
} */
</style>
